<template>
  <div>
    <nav-title />
    <div class="layout-main">
      <div class="content">
        <div class="table">
          <el-table :data="list" v-loading="loading">
            <el-table-column prop="id" label="#" width="278" align="center">
            </el-table-column>
            <el-table-column
              prop="name"
              label="标签名称"
              width="278"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <i class="icon el-icon-edit" @click="openDiglog(scope.row)"></i>
                <i
                  class="icon el-icon-delete"
                  @click="handleDelete(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            class="cl-pagination"
            layout="prev, pager, next , sizes"
            @size-change="handleSizeChange"
            @current-change="handleChangePage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            :total="total"
          >
          </el-pagination>
        </div>
        <div class="form">
          <h3 class="title">新增标签</h3>
          <el-input
            size="small"
            placeholder="请输入新增标签"
            class="input"
            v-model="tagName"
          ></el-input>
          <el-button type="primary" size="small" @click="handleAdd"
            >提交</el-button
          >
        </div>
      </div>
      <el-dialog
        title="编辑标签"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
      >
        <el-form>
          <el-form-item label="标签名称">
            <el-input v-model="form.name" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleEdit">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import NavTitle from 'components/NavTitle';
import ListMixins from '../../mixins/list';
import warning from 'assets/images/warning.png';

export default {
  name: 'TagsList',
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'elementTag',
      tagName: '',
      form: {},
      dialogVisible: false,
      filterValues: {
        type: 3
      }
    };
  },
  methods: {
    handleAdd() {
      this.$store
        .dispatch(this.namespace + '/save', {
          name: this.tagName,
          type: 3
        })
        .then(data => {
          this.$message.success('新增成功');
          this.tagName = '';
          this.fetchData(this.filterValues);
        });
    },
    handleDelete(data) {
      this.$confirm(
        `
            <img src=${warning} alt="" width="59" st/>
            <p style="
                font-size: 16px;
                font-weight: bold;
                padding-bottom: 19px;
                display: block;
                color: rgba(0, 0, 0, 0.65);">
                是否删除，如删除则标签下的所有元素将删除
            </p>
		`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.$store
          .dispatch(this.namespace + '/delete', {
            id: data.id
          })
          .then(data => {
            this.$message.success('删除成功');
            this.fetchData(this.filterValues);
          });
      });
    },
    openDiglog(data) {
      this.form = JSON.parse(JSON.stringify(data));
      this.dialogVisible = true;
    },
    handleEdit() {
      this.$store.dispatch(this.namespace + '/save', this.form).then(data => {
        this.$message.success('修改成功');
        this.tagName = '';
        this.fetchData(this.filterValues);
        this.dialogVisible = false;
      });
    },
    handleClose() {
      this.dialogVisible = false;
    }
  },
  components: {
    'nav-title': NavTitle
  }
};
</script>
<style lang="scss" scoped>
.layout-main {
  padding-top: 0;
}
.cl-pagination {
  padding-bottom: 0;
}
.content {
  display: flex;
  width: 100%;
}
.table {
  width: 100%;
  padding-right: 16px;
  padding-top: 24px;
  .icon {
    color: #3fb7ff;
    cursor: pointer;
    & + .icon {
      margin-left: 16px;
    }
  }
}
.form {
  padding: 30px 0 0 25px;
  width: 254px;
  flex-shrink: 0;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 100%;
    background-image: linear-gradient(
      90deg,
      hsla(0, 0%, 100%, 0),
      hsla(0, 0%, 84.7%, 0.28)
    );
    top: 0;
    left: 0;
  }
  .title {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.65);
  }
  .input {
    margin: 20px 0 12px;
  }
}
</style>
